module.exports = __webpack_public_path__ + "static/media/PassExample.577ec7b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/PassExample.jpg
// module id = 1618
// module chunks = 0